export default __webpack_public_path__ + "static/media/Despair.c6242abd.png";